import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import { useTranslation } from "react-i18next";
import { Heading } from "src/components/base/heading";
import { Text } from "src/components/base/text";

/**
 * The properties for {@link ErrorDisabledLogin}
 */
export type ErrorDisabledLoginProps = {};

/**
 * The error page for tailscale user authentication
 */
export default function ErrorDisabledLogin(props: ErrorDisabledLoginProps) {
    const [t] = useTranslation("static");

    return (
        <div className={"flex flex-col items-center justify-center gap-4"}>
            <Heading>{t("heading.tailscale-disabled")}</Heading>
            <Text>{t("description.tailscale-disabled")}</Text>
        </div>
    );
}

export const Route = createFileRoute("/_static/s/login/disabled")({
    component: ErrorDisabledLogin,
});
